import React, { useRef, useState } from 'react';
import { Graphviz } from 'graphviz-react';
import CopyButton from '../common/CopyButton';

interface GraphvizViewerProps {
  dotSource: string;
  width?: number;
  height?: number;
  className?: string;
  style?: React.CSSProperties;
}

export const GraphvizViewer: React.FC<GraphvizViewerProps> = ({
  dotSource,
  width = 800,
  height = 600,
  className,
  style
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [error] = useState<string | null>(null);


  if (!dotSource) {
    return (
      <div 
        ref={containerRef}
        className={className}
        style={{
          ...style,
          width,
          height,
          border: '1px solid #ddd',
          borderRadius: '4px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#f9f9f9',
          color: '#666'
        }}
      >
        No graph data available
      </div>
    );
  }

  return (
    <div 
      ref={containerRef}
      className={className}
      style={{
        ...style,
        width,
        height,
        border: '1px solid #ddd',
        borderRadius: '4px',
        overflow: 'hidden',
        position: 'relative',
        background: 'white'
      }}
    >
      {/* Copy button */}
      <CopyButton 
        textToCopy={dotSource} 
        buttonText="📋 Copy DOT"
        position="top-right"
      />

      {/* Error indicator */}
      {error && (
        <div style={{
          position: 'absolute',
          top: '8px',
          left: '8px',
          zIndex: 10,
          background: '#ffe6e6',
          color: '#d00',
          padding: '6px 12px',
          borderRadius: '4px',
          border: '1px solid #ff9999',
          fontSize: '12px'
        }}>
          {error}
        </div>
      )}

      {/* Graphviz component with built-in zoom and pan */}
      <Graphviz
        dot={dotSource}
        options={{
          fit: true,
          height: height || 600,
          width: width || 800,
          zoom: true
        }}
      />
    </div>
  );
};